import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import StampIcon from '@icons/StampIcon';
import { IconProps } from '@models/icons';
import { JSX } from 'react';

interface Props {
    icon: (props: IconProps) => JSX.Element,
    label: string;
    content: string;
    onClick?: () => void;
}

function UserRewardItem({
  icon: Icon, label, content, onClick,
}:Props) {
  return (
        <Container onClick={onClick}>
            <Icon size={24} color={colors.gray7}/>
            <Column>
                <Text color={colors.gray7} size='s'>{label}</Text>
                <Text color={colors.gray9} fontWeight='bold' css={css`white-space: nowrap`}>
                    {content}
                </Text>
            </Column>
        </Container>
  );
}

const Container = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;
    flex-grow: 1;
    padding: 16px 0;
    justify-content: center;
`;

export default UserRewardItem;
